import { useGetMyAccountSelector } from '../store/rtk-query/apis/account/selectors/get-account-by-id.selector';
import { PricingPlan } from '../enums/user-plan.enum';

export const useShouldLockFeature = (): boolean => {
  const { data: { plan } } = useGetMyAccountSelector();

  return !plan?.pricingPlan || plan.pricingPlan === PricingPlan.Lite;
};
